import React from 'react';
import Releases from '../components/Releases';

const ReleasesOverview = () => {
  return <Releases />;
};

export default ReleasesOverview;
